import {
  KeyValueElevatedRoleModel,
  KeyValueIsDisabledModel,
  KeyValueIsPrimary,
  KeyValueModel,
  KeyValueType,
} from '@models/common';
import { FileItemModel } from '@models/module/fields/main';
import { Currency } from '@models/system';
import { PrimaryUser } from '@module-instance/assignments/primary-users-dialog/primary-user-dialog.model';

export type DictionaryType<T = KeyValueType> = {
  data: T[];
  timestamp: number;
};

export type DictionaryState = {
  //   instantResponse: boolean;
  dynamic: Record<string, DictionaryType>;
  predefined: {
    currencies?: Currency[];
    countryCodes?: DictionaryType<KeyValueType<string, string>>;
    industries?: DictionaryType<KeyValueType<number, string>>;
    intervalDict?: DictionaryType<KeyValueType<number, string>>;
    organizations?: Record<string, DictionaryType<KeyValueType<number, string>>>;
    roles?: DictionaryType<KeyValueElevatedRoleModel<number, string>>;
    primaryUsers?: Record<string, DictionaryType<PrimaryUser>>;
    tagUsers?: Record<string, DictionaryType<KeyValueType>>;
    moduleRoles?: Record<string, DictionaryType<KeyValueType<number>>>;
    moduleUserRoles?: Record<string, DictionaryType<KeyValueType<number>>>;
    folderFiles?: Record<string, DictionaryType<FileItemModel>>;
    userTemplates?: Record<string, DictionaryType<KeyValueIsPrimary<number>>>;
    usersDict?: DictionaryType<KeyValueIsDisabledModel<number, string>>;
    contractsDict?: Record<string, DictionaryType<KeyValueType<number, string>>>;
    mimeTypesDict?: DictionaryType<KeyValueModel<number, string>>;
  };
};

export type PredefinedDictionaryKey = keyof DictionaryState['predefined'] | 'dynamic';

export const initialDatasourceState: DictionaryState = {
  //   instantResponse: true,
  dynamic: {},
  predefined: {
    currencies: null,
    countryCodes: null,
    industries: null,
    intervalDict: null,
    organizations: null,
    roles: null,
    primaryUsers: null,
    tagUsers: null,
    moduleRoles: null,
    moduleUserRoles: null,
    folderFiles: null,
    userTemplates: null,
    usersDict: null,
    contractsDict: null,
    mimeTypesDict: null,
  },
};

export type DictionaryParams = {
  dataSourceId: number;
  relationId: number;
  contractId: number;
  moduleId: number;
  entityInstanceId: number;
  selectedIds: string[];
  fieldId: number;

  /* For FolderFile */
  isFolders?: boolean;
  rootModuleId?: number;
  /** Project Files only: lists global folders instead of the current context's tree. */
  isGlobal?: boolean;

  /** For contracts dict keyed per user */
  userId?: number;
};

export enum DictionaryValidTime {
  SHORT = 10 * 1000, // 10 seconds
  DEFAULT = 5 * 60 * 1000, // 5 minutes
}

export enum DictionaryStoreActions {
  SetScopedDictionary = '[Dictionary] Set Scoped Dict',
  SetCurrencies = '[Dictionary] Set Currencies',
  SetCountryCodes = '[Dictionary] Set Country Codes',
  SetIndustries = '[Dictionary] Set Industries',
  SetIntervalDict = '[Dictionary] Set Interval Dict',
  SetOrganizations = '[Dictionary] Set Organizations',
  SetRoles = '[Dictionary] Set Roles',
  SetPrimaryUsers = '[Dictionary] Set Primary Users',
  ClearState = '[Dictionary] Clear State',
  ToggleInstant = '[Dictionary] Toggle Instant Response',
  SetModuleRoles = '[Dictionary] Set Module Roles',
  SetModuleUserRoles = '[Dictionary] Set Module User Roles',
  SetFolderFiles = '[Dictionary] Set Folder Files',
  SetUserTemplates = '[Dictionary] Set User Templates',
  SetTagUsers = '[Dictionary] Set Tag Users',
  SetUsersDict = '[Dictionary] Set Users Dict',
  SetContractsDict = '[Dictionary] Set Contracts Dict',
  SetMimeTypesDict = '[Dictionary] Set Mime Types Dict',
}
